import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const MediDetail = () => {
  const { id } = useParams();
  const [voucher, setVoucher] = useState('');
  const [verified, setVerified] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [paymentOption, setPaymentOption] = useState('');
  const [voucherVisible, setVoucherVisible] = useState(false);

  const medi = {
    id: 1,
    title: "Paracetamol 500mg Tablets",
    location: "GlaxoSmithKline, Nashik, Maharashtra",
    description:
      "Effective for fever and mild to moderate pain relief. Fast-acting and widely used across India.",
    mediPrice: 45,
    offerPrice: 35,
    business: {
      name: "GlaxoSmithKline Pharmaceuticals Ltd.",
      type: "Allopathy",
      contact: "info@gsk.com",
      location: "Nashik, Maharashtra"
    },
    userReviews: 987,
    image: `/api/downloads/thinkmedicine/medicines/${id}.png`
  };

  const handleVerify = () => {
    if (voucher === 'LOVE50') {
      setVerified(true);
      setDiscount(50);
    } else {
      setVerified(false);
      setDiscount(0);
    }
  };

  const finalPrice = discount > 0 ? medi.offerPrice * (1 - discount / 100) : medi.offerPrice;

  const handleOrderNow = () => {
    if (paymentOption) {
      setVoucherVisible(true);
    } else {
      alert('Please select a payment option before ordering.');
    }
  };

  const handleDownloadPDF = async () => {
    const input = document.getElementById('voucherSection');
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${medi?.title || "voucher"}.pdf`);
  };

  return (
    <div className="text-white p-6 max-w-4xl mx-auto bg-gradient-to-br from-yellow-400 to-green-500 rounded-xl shadow-lg">
      <img src={medi.image} alt={medi.title} className="w-full h-64 object-cover rounded mb-4 shadow-md" />

      <h2 className="text-3xl font-bold text-white">{medi.title}</h2>
      <p className="text-white mb-4">{medi.location}</p>

      <div className="text-white">
        <p>{medi.description}</p>
        <p className="mt-2">Original Price: ₹{medi.mediPrice}</p>
        <p>Offer Price: ₹{medi.offerPrice}</p>
        {discount > 0 && (
          <p className="text-green-900 font-bold">Discount Applied: ₹{medi.offerPrice - finalPrice}</p>
        )}
        <p className="text-xl mt-2 font-semibold text-black">Final Price: ₹{finalPrice}</p>
      </div>

      <div className="mt-4 text-blue-800 bg-gray-100 p-4 rounded-md">
        <h3 className="text-yellow-400 font-semibold mb-2">Business Details</h3>
        <p className='text-black'>{medi.business.name} ({medi.business.type})</p>
        <p className='text-black'>{medi.business.location}</p>
        <p className='text-black'>{medi.business.contact}</p>
      </div>

      <div className="mt-6">
        <h4 className="font-semibold mb-2 text-white">Select Payment Option:</h4>
        <div className="space-y-2">
          {["Pay Online", "I have Paid", "Will Pay At Counter"].map(opt => (
            <label key={opt} className="block text-white">
              <input
                type="radio"
                name="payment"
                value={opt}
                onChange={(e) => setPaymentOption(e.target.value)}
              />
              <span className="ml-2">{opt}</span>
            </label>
          ))}
        </div>
        {paymentOption && (
          <p className="mt-2 text-white">You selected: {paymentOption}</p>
        )}
        <button
          className="mt-4 px-6 py-2 bg-green-800 hover:bg-green-900 text-white font-semibold rounded-full"
          onClick={handleOrderNow}
          disabled={!paymentOption}
        >
          Order Now
        </button>

        {voucherVisible && (
          <>
            <div className="mt-8 bg-white text-black shadow-lg rounded-lg p-4" id="voucherSection">
              <img
                src={medi?.image || "/default-medi.jpg"}
                alt="Medicine"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />

              <h2 className="text-2xl font-bold">{medi?.title}</h2>
              <h3 className="text-lg text-gray-800 mb-2">{medi?.location}</h3>
              <p className="text-gray-900 mb-4">{medi?.description}</p>

              <div className="text-base space-y-1 mb-4">
                <p><strong>Original Price:</strong> ₹{medi?.mediPrice}</p>
                <p><strong>Offer Price:</strong> ₹{medi?.offerPrice}</p>
                <p><strong>Final Price:</strong> ₹{finalPrice}</p>
              </div>

              <h4 className="text-lg font-semibold mt-4 mb-2">Company / Seller Details</h4>
              <div className="text-sm space-y-1">
                <p><strong>{medi?.business.name}</strong> ({medi?.business.type})</p>
                <p>{medi?.business.location}</p>
                <p>{medi?.business.contact}</p>
              </div>
            </div>

            <button
              onClick={handleDownloadPDF}
              className="mt-6 px-6 py-2 bg-yellow-600 text-white rounded-full hover:bg-yellow-700"
            >
              Download Details
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MediDetail;
